import _isFunction from "lodash/isFunction";
import { mapCustomize } from "../utils/customize";
var defaultLayout = function defaultLayout() {
  return import("../layouts/LeftSideCalloutLayout");
};
export function loadLayout(layoutName) {
  if (mapCustomize.has({
    module: 'hzero-front',
    feature: 'layout',
    key: layoutName
  })) {
    var layout = mapCustomize.get({
      module: 'hzero-front',
      feature: 'layout',
      key: layoutName
    });
    return _isFunction(layout && layout.component) ? layout.component : defaultLayout;
  }
  return defaultLayout;
}
export function setLayout(layoutName, layout) {
  var cover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!mapCustomize.has({
    module: 'hzero-front',
    feature: 'layout',
    key: layoutName
  }) || cover && mapCustomize.has({
    module: 'hzero-front',
    feature: 'layout',
    key: layoutName
  })) {
    mapCustomize.set({
      module: 'hzero-front',
      feature: 'layout',
      key: layoutName,
      data: {
        component: layout
      }
    });
  }
}